import type { Locale } from "../schema/Locale.js";
import { NamedError } from "./NamedError.js";
import { findExpectedAppSyncErrorMessage } from "./aws/appsync/findExpectedAppSyncErrorMessage.js";
import { getExpectedError } from "./getExpectedError.js";

export function expectErrorMessage(
	error: unknown,
	locale: Locale,
	expectedError: Record<string, string | ((error: Error) => string)> = {},
	defaultMessage?: string,
): string | undefined {
	if (error instanceof NamedError || error instanceof Error) {
		const expected = expectedError[error.name];
		if (typeof expected === "function") {
			return expected(error);
		} else if (typeof expected === "string") {
			return expected;
		}
	}

	const expectedFromSystem = getExpectedError(error, locale);
	if (expectedFromSystem) {
		return expectedFromSystem;
	}

	return findExpectedAppSyncErrorMessage(error, expectedError) ?? defaultMessage;
}
